import { action, computed, makeObservable, observable } from 'mobx';
import { persist } from 'mobx-persist';
import moment from 'moment';
import { appStore } from '../appStore';
import { PER_PAGE } from 'src/constants/main';
import client from 'src/services/client';
import { TBooleanInNumber, TTranslate } from 'src/types/main';
import { getLastArrayItem } from 'src/utils/helpers';
import logger from '~/services/logger';

export interface ICountry {
  id: number;
  name: TTranslate;
  place_id: string; // google place id
  numeric_code?: number;
  alfa_2_code?: string;
  isd_code?: string;
  status: number;
  created_at: string;
  is_default: TBooleanInNumber;
}

export class CountriesStore {
  constructor() {
    makeObservable(this);
  }

  public get persist() {
    return true;
  }

  @observable loading: boolean = false;
  @persist @observable timestamp: number | null = null;
  @persist('object') @observable countries: ICountry[] | undefined = undefined;

  @computed get countriesForPhoneInput() {
    return this.countries?.reduce((sum: string[], current) => {
      if (current.alfa_2_code) return sum.concat(current.alfa_2_code.toString().toLowerCase());
      return sum;
    }, []);
  }

  @computed get defaultCountryCode(): string {
    return (
      this.countries?.find((country) => country.is_default)?.alfa_2_code?.toLowerCase() ||
      getLastArrayItem<ICountry>(this.countries)?.alfa_2_code?.toLowerCase() ||
      appStore.settings?.default_country_code.toString().toLowerCase() ||
      '966'
    );
  }

  @action fetchCountries = async () => {
    try {
      if (!this.timestamp || moment(this.timestamp).add(5, 'minutes').isBefore(moment())) {
        this.loading = true;
        const response = await client.get(`/v3/countries`, { params: { status: 1, per_page: PER_PAGE.MAXIMUM } });
        this.countries = response.data;
        this.timestamp = Date.now();
        this.loading = false;
      }
    } catch (error: any) {
      this.loading = false;
      logger.error({ error, place: 'CountriesStore fetchCountries' });
    }
  };
}

const countriesStore = new CountriesStore();

export { countriesStore };
